import React, { useState, useEffect } from 'react';
import StepIcon from '../NextSteps/StepIcon';
import ExpandSVG from '../../assets/ExpandSVG';

const TaskItem = ({
    taskKey,
    subTaskKey, // if applicable
    number,
    title,
    description,
    due,
    onCardClick,
    isExpanded,
    nextStepsState = {},
    toggleCompletion,
  }) => {
    // For tasks like "inspection", check the string state; for others, check the boolean.
// console.log("nextStepsState in TaskItem", nextStepsState);

        const isCompleted =
        taskKey === "inspection" || taskKey === "title" || taskKey === "appraisal" || taskKey === "lender" || taskKey === "insurance" || taskKey === "utilities" || taskKey === "closing" || taskKey === "walkthrough" || taskKey === "closingDay" || taskKey === "depositEarnestMoney"
        ? nextStepsState[taskKey]?.state === "Completed"
        : subTaskKey
        ? nextStepsState[taskKey]?.subSteps?.[subTaskKey]?.completed
        : nextStepsState[taskKey]?.completed;

        return (
            <div className="inline-flex flex-col w-full cursor-pointer" onClick={onCardClick}>
              <div
                className={`inline-flex gap-4 md:gap-10 justify-between items-center py-3 pr-5 pl-2.5 w-full font-medium ${
                  isExpanded ? 'bg-shi-light-mysterious-green' : 'bg-white'
                }`}
              >
                <div className="inline-flex justify-between gap-2 items-center md:pl-3">
                  <div className="flex gap-1.5 items-center">
                    {onCardClick && (
                      <div
                        className={`transform transition-transform duration-300 ${
                          isExpanded ? 'rotate-180' : 'rotate-0'
                        }`}
                      >
                        <ExpandSVG width={16} height={16} />
                      </div>
                    )}
                    <StepIcon completed={isCompleted} width={28} height={28} mr-2>
                      {number}
                    </StepIcon>
                  </div>
                  <div className="flex flex-col ml-2">
                    <div className="text-[11px] md:text-[13px] text-black">{title}</div>
                    <div className="text-[10px] md:text-[12px] mt-1 text-slate-600">{description}</div>
                    <div className="text-[10px] md:text-[12px] mt-1 text-slate-600">{due}</div>
                  </div>
                </div>
                <button
                  className={`px-1 py-1 text-[11px] md:text-[12px] whitespace-nowrap min-w-[80px] ${
                    isCompleted
                      ? 'bg-shi-green border border-shi-green text-white'
                      : 'border border-shi-green bg-white'
                  } rounded hover:bg-slate-200 hover:text-shi-green`}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent toggling the drawer when clicking the button.
                    toggleCompletion(taskKey);
                  }}
                >
                  {isCompleted ? 'Mark Undone' : 'Complete'}
                </button>
              </div>
            </div>
          );
        };
        
        export default TaskItem;